import _regeneratorRuntime from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/opt/www/game/xcp-vue-xc01/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import infoList from "@/mixins/infoList";
import { createApp, getAppInfo, updateApp } from "@/api/app";
import UploadImage from "@/components/upload/image.vue";
import { mapGetters, mapMutations } from "vuex";
export default {
  name: "appBaseConfig",
  mixins: [infoList],
  components: {
    UploadImage: UploadImage
  },
  computed: _objectSpread({}, mapGetters("app", ["selectAppId", "isAdd"])),
  data: function data() {
    return {
      form: {
        app_id: 0,
        name: "",
        created: "",
        updated: "",
        capabilities: "",
        app_pay_date: 1,
        app_type: "",
        is_focus: 0,
        is_share: 1,
        is_test_app: 0,
        is_wxmini_game: 0,
        is_wxmini_pro: 0,
        is_add_reqdata: 0,
        logo: "",
        login_mode: "",
        is_super_kefu: "",
        is_show_vip: "",
        is_show_qqun: "",
        is_gift: "",
        is_more_game: ""
      }
    };
  },
  filters: {},
  methods: _objectSpread(_objectSpread({}, mapMutations("app", ["setSelectAppId", "setIsAdd", "setIsChangeAppInfo"])), {}, {
    saveApp: function saveApp() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!_this.isAdd) {
                _context.next = 5;
                break;
              }
              _context.next = 3;
              return createApp(_this.form).then(function (data) {
                if (data.code == 0) {
                  _this.setSelectAppId(data.data.appId);
                }
                _this.$message.success(data.msg);
              });
            case 3:
              _context.next = 7;
              break;
            case 5:
              _context.next = 7;
              return updateApp(_this.form).then(function (data) {
                _this.$message.success(data.msg);
              });
            case 7:
              _this.setIsChangeAppInfo(1); // 设置vuex中isChangeAppInfo,重载下拉菜单
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    changeAppInfo: function changeAppInfo(AppId) {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getAppInfo({
                app_id: AppId
              });
            case 2:
              res = _context2.sent;
              if (res.code == 0) {
                _this2.setIsAdd(0);
                _this2.form = res.data.app;
              }
              _this2.$message.success(res.msg);
            case 5:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    }
  }),
  created: function created() {
    if (this.selectAppId != "") {
      this.changeAppInfo(this.selectAppId);
    }
  },
  watch: {
    selectAppId: function selectAppId(appId) {
      if (appId) {
        this.changeAppInfo(appId);
      }
    },
    isAdd: function isAdd(_isAdd) {
      if (_isAdd) {
        for (var key in this.form) {
          this.form[key] = "";
        }
      }
    }
  }
};